import React from 'react';
import Lottie from 'react-lottie';

const Animation = ({
  animation,
  loop = true,
  width,
  height,
  moreRendererSettings,
  ...props
}) => {
  const defaultOptions = {
    loop,
    autoplay: true,
    animationData: animation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
      ...moreRendererSettings,
    },
    ...props,
  };
  return (
    <Lottie
      options={{
        ...defaultOptions,
      }}
      width={width}
      height={height}
    />
  );
};

export default Animation;
